import React from 'react'

const FullScreenLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center bg-loder' style={{ top: 0, left: 0, zIndex: 99999 }}>
            <span className="loader"></span>
        </div>
    )
}

export default FullScreenLoader
